var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelemetrieDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TELEMETRIE_DOWN"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-342",
    x: 8.07949,
    y: 8.07975,
    width: 43.841,
    height: 43.841,
    rx: 10,
    ry: 10,
    transform: "translate(-12.42659 30.00007) rotate(-45)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-352",
    x: 10.01836,
    y: 11.83799,
    width: 39.96329,
    height: 39.96329,
    rx: 10,
    ry: 10,
    transform: "translate(-13.71308 30.53296) rotate(-45)",
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15515,37.99351h-1.96978c-.4491-1.4273-.67715-2.91482-.67621-4.41115.00436-3.89736,1.55449-7.63373,4.31032-10.38955,2.75582-2.75583,6.49224-4.30599,10.38959-4.31036,3.89736.00436,7.63373,1.55452,10.38955,4.31036,2.75594,2.75582,4.30602,6.49219,4.31037,10.38955.00153,1.49551-.22614,2.98232-.67502,4.4088h-4.93917c.26036-.73041.44441-1.48599.54919-2.25438.39102-2.64822-.26989-5.34418-1.84161-7.51107l-8.12494,8.80584s-1.62993.38455-2.23439-.33398-.17993-2.54132-.17993-2.54132l10.31346-6.23276-.08349-.10466c-.98348-1.19704-2.2231-2.15795-3.62747-2.81192-1.40449-.65397-2.93775-.98431-4.48688-.96655-2.67832.01588-5.27064.9475-7.34642,2.6401-1.66474,1.31782-2.92838,3.0744-3.64853,5.07171-.72014,1.99743-.8682,4.1562-.42746,6.23312,0,0-.00119.00823-.00118.00822Z",
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetrieDownIcon);
export default __webpack_public_path__ + "static/media/TelemetrieDownIcon.0c8a4246a7e949981b5cdabd2acb0219.svg";
export { ForwardRef as ReactComponent };